// Async signature though the lookup is local, so callers stay unchanged the day this moves
// to an API route. With one provider this checks membership, not discovery: never let "SSO"
// become a synonym for "internal".

// Must match ProviderName in inside-api Cognito config; renaming there breaks this silently.
const FREELANCE_PROVIDER = 'azure-entra-id-freelancecom';

// Per domain, not a suffix test, so lookalike domains don't match.
const PROVIDER_BY_DOMAIN: Record<string, string> = {
    'freelance.com': FREELANCE_PROVIDER,
};

const domainOf = (email: string): string | null => {
    const at = email.lastIndexOf('@');
    if (at < 1 || at === email.length - 1) {
        return null;
    }
    return email
        .slice(at + 1)
        .trim()
        .toLowerCase();
};

export const findSsoProvider = async (email: string): Promise<string | null> => {
    const domain = domainOf(email);
    return domain ? (PROVIDER_BY_DOMAIN[domain] ?? null) : null;
};
